import zhCn from 'element-plus/es/locale/lang/zh-cn';
import getHostData from '@/scripts/hostData';
import { useRoute } from 'vue-router';

import { provide, watch } from 'vue';
import { useRouter } from 'vue-router';
export default {
  name: 'App',
  components: {},

  setup() {
    provide('hostValue', getHostData()); //在需要页面调用inject，如const hostValue = inject('hostValue')

    const route = useRoute();
    const router = useRouter();
    watch(() => route.query, (newQuery, oldQuery) => {
      const companyType = sessionStorage.getItem('companyType');

      if (companyType === 'yc' && !newQuery.companyType) {
        router.push({
          path: route.path,
          query: { ...newQuery,
            companyType: companyType
          }
        });
      }
    });
    return {
      locale: zhCn
    };
  }

};